import i18n from '../services/translations';

export const identificationTypes = [
  { id: 0, name: 'CC' },
  { id: 1, name: 'CE' },
  { id: 2, name: 'Passport' }
];

export const roleTypesList = [
  { id: 1, name: i18n.t('roles.rtv') },
  { id: 2, name: i18n.t('roles.custody') },
  { id: 3, name: i18n.t('roles.dm') },
  { id: 4, name: i18n.t('roles.apTeam') }
];

export const formTypesList = [
  { id: 1, name: i18n.t('evaluationForm.typeEvaluation') },
  { id: 2, name: i18n.t('evaluationForm.typeTracking') },
  { id: 3, name: i18n.t('evaluationForm.typePosHarvest') }
];

export const departmentsList = [
  { id: 1, name: 'Bogotá D.C' },
  { id: 2, name: 'Amazonas' },
  { id: 3, name: 'Antioquia' },
  { id: 4, name: 'Arauca' },
  { id: 5, name: 'Atlántico' },
  { id: 6, name: 'Bolívar' },
  { id: 7, name: 'Boyacá' },
  { id: 8, name: 'Caldas' },
  { id: 9, name: 'Caquetá' },
  { id: 10, name: 'Casanare' },
  { id: 11, name: 'Cauca' },
  { id: 12, name: 'Cesar' },
  { id: 13, name: 'Chocó' },
  { id: 14, name: 'Córdoba' },
  { id: 15, name: 'Cundinamarca' },
  { id: 16, name: 'Guainía' },
  { id: 17, name: 'Guaviare' },
  { id: 18, name: 'Huila' },
  { id: 19, name: 'La Guajira' },
  { id: 20, name: 'Magdalena' },
  { id: 21, name: 'Meta' },
  { id: 22, name: 'Nariño' },
  { id: 23, name: 'Norte de Santander' },
  { id: 24, name: 'Putumayo' },
  { id: 25, name: 'Quindío' },
  { id: 26, name: 'Risaralda' },
  { id: 27, name: 'San Andres Providencia' },
  { id: 28, name: 'Santander' },
  { id: 29, name: 'Sucre' },
  { id: 30, name: 'Tolima' },
  { id: 31, name: 'Valle del Cauca' },
  { id: 32, name: 'Vichada' },
  { id: 33, name: 'Vaupés' },
  { id: 34, name: 'Archipiélago de San Andrés, Providencia y Santa Catalina' }
];
